export default "__VITE_ASSET__DvxSPTe5__"